import { keepPreviousData, useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ContentAnalysisV2Scope } from 'src/services/contentAnalysisApi/interfaces/contentAnalysisV2.interface'
import { ContentAnalysisV2ApiService } from 'src/services/contentAnalysisV2Api'

export const useGetContentAnalysisV2OverviewQuery = (
  scope: ContentAnalysisV2Scope
) =>
  useQuery({
    placeholderData: keepPreviousData,
    queryFn: () => ContentAnalysisV2ApiService.getOverview(scope),
    queryKey: [
      QueryKey.GET_CONTENT_ANALYSIS_V2_OVERVIEW,
      scope.analysisIds?.join(','),
      scope.from,
      scope.to,
      scope.period,
      scope.platform,
    ],
  })
